import { useEffect, useRef } from 'react';

const PALETTE = ['245,203,68', '255,240,186', '250,224,115', '255,249,230'];

export const ButterCanvas = ({ className = '' }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext('2d');
    let raf;
    let w = 0;
    let h = 0;

    const mouse = { x: 0.5, y: 0.5 };
    const smooth = { x: 0.5, y: 0.5 };

    const blobs = Array.from({ length: 7 }, (_, i) => ({
      bx: 0.15 + Math.random() * 0.7,
      by: 0.15 + Math.random() * 0.7,
      r: 0.16 + Math.random() * 0.2,
      sp: 0.00022 + Math.random() * 0.0004,
      ph: Math.random() * Math.PI * 2,
      amp: 0.05 + Math.random() * 0.08,
      depth: 0.3 + Math.random() * 0.7,
      col: PALETTE[i % PALETTE.length],
      a: 0.4 + Math.random() * 0.35,
    }));

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener('resize', resize);

    const onMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = (e.clientX - rect.left) / Math.max(rect.width, 1);
      mouse.y = (e.clientY - rect.top) / Math.max(rect.height, 1);
    };
    window.addEventListener('mousemove', onMove);

    const draw = (t) => {
      smooth.x += (mouse.x - smooth.x) * 0.045;
      smooth.y += (mouse.y - smooth.y) * 0.045;
      ctx.clearRect(0, 0, w, h);
      for (const b of blobs) {
        const x = (b.bx + Math.sin(t * b.sp + b.ph) * b.amp + (smooth.x - 0.5) * 0.14 * b.depth) * w;
        const y = (b.by + Math.cos(t * b.sp * 1.3 + b.ph) * b.amp + (smooth.y - 0.5) * 0.14 * b.depth) * h;
        const r = b.r * Math.min(w, h) * (1 + Math.sin(t * b.sp * 2 + b.ph) * 0.07);
        const g = ctx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, `rgba(${b.col},${b.a})`);
        g.addColorStop(1, `rgba(${b.col},0)`);
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      window.removeEventListener('mousemove', onMove);
    };
  }, []);

  return <canvas ref={ref} data-testid="butter-canvas" className={className} aria-hidden="true" />;
};
